import React, { useCallback, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import GeoHelper from '../geoHelper'
import actions from '../actions'

import PositionDialog from './PositionDialog'
import GEO_PERMISSION_STATUS from '../Enum/GeoPermissionStatus'

export function usePositionHandler(config) {
  const position = useSelector((state) => state.position)

  const dispatch = useDispatch()
  const mounted = useRef(false)

  // usado nas buscas
  const getParams = useCallback(() => {
    const pos = position.customLocation || position.user || {}
    return {
      lat: pos.lat,
      lng: pos.lng,
      cnpj: config.cnpj,
      partner: config.partner,
      tag: config.tag
    }
  }, [position?.customLocation, position?.user, config?.cnpj, config?.partner, config?.tag])

  const getAddress = () => {
    if (position.user) return position.user

    return {
      city: position.customLocation.address.city,
      state: position.customLocation.address.state,
      district: position.customLocation.address.district,
      zipCode: position.customLocation.address.postalCode,
      country: position.customLocation.address.country
    }
  }

  const handlerShowPositionDialog = (show) => {
    dispatch(actions.position.change({ showPositionDialog: show }))
  }

  useEffect(() => {
    mounted.current = true
    return () => (mounted.current = false)
  }, [])

  const getBrowserPosition = (res) => {
    GeoHelper.getPositionBrowser()
      .then(GeoHelper.fetchReverseGeocode)
      .then((user) =>
        dispatch(
          actions.position.change({
            user,
            permission: res,
            fetched: true,
            showMapPlaceholder: false
          })
        )
      )
      .catch((error) => {
        dispatch(actions.position.change({ fetched: true, showMapPlaceholder: false }))
        if (error.message === 'User denied Geolocation') {
          dispatch(actions.position.updatePermission('denied'))
        }
      })
  }

  useEffect(() => {
    GeoHelper.getPermission().then((res) => {
      if (!mounted.current) return

      if (res === GEO_PERMISSION_STATUS.granted && !position.user?.lat && !position.user?.lng) {
        getBrowserPosition(res)
        return
      }

      dispatch(actions.position.change({ fetched: true, showMapPlaceholder: false }))
      handlerShowPositionDialog(!position.user?.lat && !position.user?.lng)
      dispatch(actions.position.updatePermission(res))
    })
  }, [mounted])

  const handleAddressSelect = (user) => {
    dispatch(
      actions.position.change({
        dialogSearchAddress: false,
        dialogSharedPosition: true,
        user,
        fetched: true,
        showMapPlaceholder: false
      })
    )
  }

  return {
    ...position,
    handlerShowPositionDialog,
    dispatch,
    handleAddressSelect,
    getParams,
    getAddress
  }
}

function PositionHandler(props) {
  return <PositionDialog />
}

export default PositionHandler
